import { createSlice } from '@reduxjs/toolkit'

const {
  actions: {
    getAllSuperAdminTransactionsStart,
    getAllSuperAdminTransactionsSuccess,
    getAllSuperAdminTransactionsFailure,
    getSuperAdminCasinoTransactionsStart,
    getSuperAdminCasinoTransactionsSuccess,
    getSuperAdminCasinoTransactionsFailure,

    // sports book start 
    getSuperAdminSportsBookTransactionsStart,
    getSuperAdminSportsBookTransactionsSuccess,
    getSuperAdminSportsBookTransactionsFailure,

    // sports book endd 

    getSuperAdminSportsTransactionsStart,
    getSuperAdminSportsTransactionsSuccess,
    getSuperAdminSportsTransactionsFailure,
    getHostRefferalDetailsStart,
    getHostRefferalDetailSuccess,
    getHostRefferalDetailsFailuire,
    getBankingTransactionsStart,
    getBankingTransactionsSuccess,
    getBankingTransactionsFailure,
    updateTransactionStatusStart,
    updateTransactionStatusSuccess,
    updateTransactionStatusFailure,
    updateCryptoTransactionStatusStart,
    updateCryptoTransactionStatusSuccess,
    updateCryptoTransactionStatusFailure


  },
  reducer
} = createSlice({
  name: 'transactions',
  initialState: {
    loading: false,
    transactions: {},
    casinoTransactions: {},
    sportTransactions: {},
    refferedUsers: {},
    sportsBookTransactions: {},
    loadingCrypto: false,
  },
  reducers: {
    getAllSuperAdminTransactionsStart: (state) => ({
      ...state,
      loading: true,
      error: null
    }),
    getAllSuperAdminTransactionsSuccess: (state, { payload }) => ({
      ...state,
      loading: false,
      transactions: payload
    }),
    getAllSuperAdminTransactionsFailure: (state) => ({
      ...state,
      loading: false
    }),
    getBankingTransactionsStart: (state) => ({
      ...state,
      loading: true,
      error: null
    }),
    getBankingTransactionsSuccess: (state, { payload }) => ({
      ...state,
      loading: false,
      transactions: payload
    }),
    getBankingTransactionsFailure: (state) => ({
      ...state,
      loading: false
    }),
    getSuperAdminCasinoTransactionsStart: (state) => ({
      ...state,
      loading: true,
      error: null
    }),
    getSuperAdminSportsTransactionsSuccess: (state, { payload }) => ({
      ...state,
      loading: false,
      sportTransactions: payload
    }),
    getSuperAdminSportsTransactionsFailure: (state) => ({
      ...state,
      loading: false
    }),
    getSuperAdminSportsTransactionsStart: (state) => ({
      ...state,
      loading: true,
      error: null
    }),
    getSuperAdminCasinoTransactionsSuccess: (state, { payload }) => ({
      ...state,
      loading: false,
      casinoTransactions: payload
    }),
    getSuperAdminCasinoTransactionsFailure: (state) => ({
      ...state,
      loading: false
    }),
    getHostRefferalDetailsStart: (state) => ({
      ...state,
      loading: true
    }),
    getHostRefferalDetailSuccess: (state, { payload }) => ({
      ...state,
      loading: false,
      refferedUsers: payload
    }),
    getHostRefferalDetailsFailuire: (state, { payload }) => ({
      ...state,
      loading: false,
      error: payload,
    }),
    updateTransactionStatusStart: (state) => ({
      ...state,
      loading: true
    }),
    updateTransactionStatusSuccess: (state) => ({
      ...state,
      loading: false,
    }),
    updateTransactionStatusFailure: (state, { payload }) => ({
      ...state,
      loading: false,
      error: payload,
    }),


    updateCryptoTransactionStatusStart: (state) => ({
      ...state,
      loadingCrypto: true
    }),
    updateCryptoTransactionStatusSuccess: (state) => ({
      ...state,
      loadingCrypto: false,
    }),
    updateCryptoTransactionStatusFailure: (state, { payload }) => ({
      ...state,
      loadingCrypto: false,
      error: payload,
    }),

    getSuperAdminSportsBookTransactionsStart: (state) => ({
      ...state,
      loading: true,
      error: null
    }),

    getSuperAdminSportsBookTransactionsSuccess: (state, { payload }) => ({
      ...state,
      loading: false,
      sportsBookTransactions: payload
    }),

    getSuperAdminSportsBookTransactionsFailure: (state) => ({
      ...state,
      loading: false
    }),

  }
})

export default reducer

export {
  getAllSuperAdminTransactionsStart,
  getAllSuperAdminTransactionsSuccess,
  getAllSuperAdminTransactionsFailure,
  getSuperAdminCasinoTransactionsStart,
  getSuperAdminCasinoTransactionsSuccess,
  getSuperAdminCasinoTransactionsFailure,
  getSuperAdminSportsTransactionsStart,
  getSuperAdminSportsTransactionsSuccess,
  getSuperAdminSportsTransactionsFailure,
  getHostRefferalDetailsStart,
  getHostRefferalDetailSuccess,
  getHostRefferalDetailsFailuire,
  getBankingTransactionsStart,
  getBankingTransactionsSuccess,
  getBankingTransactionsFailure,
  updateTransactionStatusStart,
  updateTransactionStatusSuccess,
  updateTransactionStatusFailure,
  getSuperAdminSportsBookTransactionsStart,
  getSuperAdminSportsBookTransactionsSuccess,
  getSuperAdminSportsBookTransactionsFailure,
  updateCryptoTransactionStatusStart,
  updateCryptoTransactionStatusSuccess,
  updateCryptoTransactionStatusFailure
}
